import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminConciergeQueue = lazy(() => import("@/pages/admin/AdminConciergeQueue"));

export const Route = createFileRoute("/admin/concierge-queue")({
  component: AdminConciergeQueue,
});
